import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AnalyticsConsentBannerComponent } from '@organisms/analytics-consent-banner/analytics-consent-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AnalyticsConsentBannerComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('iahoy-front');
}
